'use client';

import { Session } from 'next-auth';
import { useSession, SessionProvider } from 'next-auth/react';
import { useEffect, useState } from 'react';
import { redirect } from 'next/navigation';
import { HeroSection } from './ui/hero-section';
import { ProblemSection } from './ui/problem-section';
import { SolutionSection } from './ui/solution-section';
import { Footer } from './ui/footer';

function NosOutreachClientContent({ initialSession }: { initialSession: Session | null }) {
	const { data: session, status } = useSession();
	const [currentSession, setCurrentSession] = useState<Session | null>(initialSession);

	useEffect(() => {
		if (session) {
			setCurrentSession(session);
		}
	}, [session]);

	if (status === 'loading') {
		return (
			<div className="min-h-screen bg-gradient-to-br from-purple-50 via-blue-50 to-indigo-100 flex items-center justify-center">
				<div className="text-center">
					<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto mb-4"></div>
					<p className="text-gray-600">Loading...</p>
				</div>
			</div>
		);
	}

	return (
		<div className="min-h-screen bg-gradient-to-br from-orange-50 via-red-50 to-amber-100">
			<HeroSection session={currentSession} />
			<ProblemSection />
			<SolutionSection />
			<Footer />
		</div>
	);
}

export default function NosOutreachClient({ initialSession }: { initialSession: Session | null }) {
	return (
		<SessionProvider session={initialSession}>
			<NosOutreachClientContent initialSession={initialSession} />
		</SessionProvider>
	);
}